import { html } from '@design.estate/dees-element';
import type { IGroupedListSection } from './dees-grouped-list.js';

const sections: IGroupedListSection[] = [
  {
    header: 'General',
    rows: [
      { label: 'Username', value: 'johndoe' },
      { label: 'Email', value: 'john@example.com' },
      { label: 'Notifications', navigates: true },
    ],
    footer: 'Your username is visible to other members of your workspace.',
  },
  {
    header: 'Preferences',
    rows: [
      { icon: 'lucide:moon', iconColor: '#5856d6', label: 'Dark Mode', toggle: true },
      { icon: 'lucide:bell', iconColor: '#ff3b30', label: 'Alerts', toggle: false },
      { icon: 'lucide:globe', iconColor: '#34c759', label: 'Language', value: 'English', navigates: true },
    ],
  },
  {
    header: 'About',
    rows: [
      { label: 'Version', value: '1.2.3' },
      { label: 'Terms of Service', navigates: true },
      { label: 'Privacy Policy', navigates: true },
      { label: 'Sign Out', destructive: true, navigates: false, action: async () => console.log('sign out') },
    ],
  },
];

export const demoFunc = () => html`
  <style>
    .demo-wrapper {
      min-height: 100vh;
      padding: 32px 0;
      background: var(--dees-color-bg-canvas);
      box-sizing: border-box;
    }
    .demo-inner {
      max-width: 520px;
      margin: 0 auto;
    }
  </style>
  <div class="demo-wrapper">
    <div class="demo-inner">
      <dees-grouped-list .sections=${sections}></dees-grouped-list>
    </div>
  </div>
`;
